<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-8">
            <div class="flmid">
                <div class="flgrow">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm"
                            placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="pService.searchTerm"
                            autocomplete="off" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary">
                                <em class="fa fa-search"></em>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col pr-4 d-flex align-items-center flex-sm-row flex-column justify-content-end">
            <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefresh()"
                aria-label="Center Align">
                <em class="fas fa-sync fa-lg"></em>
            </a>
        </div>
    </div>
</div>
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex">
                    <h4 class="card-title" translate>lblCommunicationEvent</h4>
                    <div class="ml-auto" *ngIf="canEdit">
                        <button type="button" aria-label="Center Align" class="btn btn-primary mr-sm-2 mb-1"
                            (click)="onSaveChanges()" translate>lblSaveChanges</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px">#</th>
                                <th scope="col" translate>lblEventName</th>
                                <th scope="col" translate>lblActive</th>
                                <th scope="col" translate>lblAutomatic</th>
                                <th scope="col" translate>lblManual</th>
                                <th scope="col" translate>lblEmail</th>
                                <th scope="col" translate>lblSMS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="lstActionType && lstActionType.length > 0; else load_else">
                                <tr *ngFor="let act of lstActionType; let i=index">
                                    <td>{{ act.row }}</td>
                                    <td>
                                        <ngb-highlight [result]="act.actionLabelKey | translate" [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <div class="btn btn-link px-2">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    [checked]="act.isActive" id="action-isActive{{i}}"
                                                    [(ngModel)]="act.isActive">
                                                <label class="custom-control-label" for="action-isActive{{i}}"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="btn btn-link px-2">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    [checked]="act.isAutomatic" id="action-isAutomatic{{i}}"
                                                    [disabled]="!act.isConfigured"
                                                    [(ngModel)]="act.isAutomatic">
                                                <label class="custom-control-label"
                                                    for="action-isAutomatic{{i}}"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="btn btn-link px-2">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    [checked]="act.isManual" id="action-isManual{{i}}"
                                                    [(ngModel)]="act.isManual">
                                                <label class="custom-control-label" for="action-isManual{{i}}"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="btn btn-link px-2">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    [checked]="act.isEmail" id="action-isEmail{{i}}"
                                                    [(ngModel)]="act.isEmail">
                                                <label class="custom-control-label" for="action-isEmail{{i}}"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="btn btn-link px-2">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    [checked]="act.isSms" id="action-isSms{{i}}"
                                                    [(ngModel)]="act.isSms">
                                                <label class="custom-control-label" for="action-isSms{{i}}"></label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-between">
                            <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                                [pageSize]="pService.pageSize" [maxSize]="3">
                            </ngb-pagination>
                            <select class="custom-select mx-2" style="width: auto" name="pageSize"
                                [(ngModel)]="pService.pageSize">
                                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>
                                    {{item.label}}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                            <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ |
                            async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>